<template>
<div>

<!--順位表ページ_メインメニュー-->
<ul id="bbrRnk_mainMenu" class="bbrCom_tabMenu02">
  <li><a v-bind:href="$config.baseUrl + '?kd_page=standings'" class="bbrCom_current">順位表トップ</a></li>
  <template v-if="Object.keys(json.aTeamStandingsList).length">
  <li><a v-bind:href="$config.baseUrl + '?kd_page=standings&league_code=1'">ア・リーグ</a></li>
  </template>
  <template v-if="Object.keys(json.nTeamStandingsList).length">
  <li><a v-bind:href="$config.baseUrl + '?kd_page=standings&league_code=2'">ナ・リーグ</a></li>
  </template>
</ul>
<!--/順位表ページ_メインメニュー-->

<!--順位表TOP_メインコンテンツ-->
<div class="bbrCom_setStdCnt bbrCom_setColFill">
  <!--<div class="bbrCom_attHyoki"><a href="#" class="bbrCom_linkHyoki"><span>各表記について</span></a></div>-->
  <h2 class="bbrCom_ttl">順位表</h2>
  <template v-if="json.updateTime">
  <hr>
  <h3 class="bbrCom_ttlSc-ss bbrCom_txtDetail">{{ json.updateTime }}更新</h3>
  </template>
  
  
  <!-------------------------------------リーグ戦時のコーディング開始------------------------------------->
  <!--↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓-->
  <!--ア・リーグ-->
  <template v-if="Object.keys(json.aTeamStandingsList).length">
  <h3 class="bbrCom_ttlSc-t bbrCom_blCentral">ア・リーグ</h3>
  <template v-for="(teamStandingsList, index) in json.aTeamStandingsList">
  <div class="bbrCom_mb50" :key="'a'+index">
  <div class="bbrCom_wrapScrTbl bbrCom_mb10">
  <template v-if="index == '1'">
    <h3 class="bbrCom_ttlSc">東地区</h3>
  </template>
  <template v-else-if="index == '2'">
    <h3 class="bbrCom_ttlSc">中地区</h3>
  </template>
  <template v-else-if="index == '3'">
    <h3 class="bbrCom_ttlSc">西地区</h3>
  </template>
  <table class="bbrCom_tbl  bbrRnk_top-tbl bbrCom_mb20">
    <tbody>
      <tr>
        <th>順位</th>
        <th class="bbrCom_tblTxtTeam">チーム</th>
        <th>試合</th>
        <th>勝</th>
        <th>敗</th>
        <th>分</th>
        <th>勝率</th>
        <th>差</th>
      </tr>
      <template v-if="Object.keys(teamStandingsList).length">
      <tr v-for='(standing,index) in teamStandingsList' v-bind:key="index">
        <td>{{ standing.rank }}</td>
        <td class="bbrCom_tblTxtTeam"><a v-bind:href="$config.baseUrl + '?kd_page=team&team_id=' + standing.globalId"><span v-bind:class="'bbrCom_blTeam' + standing.id">{{ standing.nickname }}</span></a></td>
        <td>{{ Number(standing.win) + Number(standing.lose) + Number(standing.tie) }}</td>
        <td>{{ standing.win }}</td>
        <td>{{ standing.lose }}</td>
        <td>{{ standing.tie }}</td>
        <td>{{ standing.winRate }}</td>
        <td>{{ standing.gamesBack }}</td>
      </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="8">データ更新までお待ちください。</td>
        </tr>
      </template>
    </tbody>
  </table>
  <div v-if="Object.keys(teamStandingsList).length" class="bbrCom_txtDetail bbrCom_mb40"><a v-bind:href="$config.baseUrl + '?kd_page=standings&league_code=1'">詳細はこちら</a></div>
  </div>
  </div>
  </template>
  </template>
  <!--/ア・リーグ-->
  
  <!--ナ・リーグ-->
  <template v-if="Object.keys(json.nTeamStandingsList).length">
  <h3 class="bbrCom_ttlSc-t bbrCom_blPacific">ナ・リーグ</h3>
  <template v-for="(teamStandingsList, index) in json.nTeamStandingsList">
  <div class="bbrCom_mb50" :key="'n'+index">
  <div class="bbrCom_wrapScrTbl bbrCom_mb10">
  <template v-if="index == '1'">
    <h3 class="bbrCom_ttlSc">東地区</h3>
  </template>
  <template v-else-if="index == '2'">
    <h3 class="bbrCom_ttlSc">中地区</h3>
  </template>
  <template v-else-if="index == '3'">
    <h3 class="bbrCom_ttlSc">西地区</h3>
  </template>
  <table class="bbrCom_tbl  bbrRnk_top-tbl bbrCom_mb20">
    <tbody>
      <tr>
        <th>順位</th>
        <th class="bbrCom_tblTxtTeam">チーム</th>
        <th>試合</th>
        <th>勝</th>
        <th>敗</th>
        <th>分</th>
        <th>勝率</th>
        <th>差</th>
      </tr>
      <template v-if="Object.keys(teamStandingsList).length">
      <tr v-for='(standing,index) in teamStandingsList' v-bind:key="index">
        <td>{{ standing.rank }}</td>
        <td class="bbrCom_tblTxtTeam"><a v-bind:href="$config.baseUrl + '?kd_page=team&team_id=' + standing.globalId"><span v-bind:class="'bbrCom_blTeam' + standing.id">{{ standing.nickname }}</span></a></td>
        <td>{{ Number(standing.win) + Number(standing.lose) + Number(standing.tie) }}</td>
        <td>{{ standing.win }}</td>
        <td>{{ standing.lose }}</td>
        <td>{{ standing.tie }}</td>
        <td>{{ standing.winRate }}</td>
        <td>{{ standing.gamesBack }}</td>
      </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="8">データ更新までお待ちください。</td>
        </tr>
      </template>
    </tbody>
  </table>
  <div v-if="Object.keys(teamStandingsList).length" class="bbrCom_txtDetail bbrCom_mb40"><a v-bind:href="$config.baseUrl + '?kd_page=standings&league_code=2'">詳細はこちら</a></div>
  </div>
  </div>
  </template>
  </template>
  <!--ナ・リーグ-->
  
  <!--↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑-->
  <!-------------------------------------リーグ戦時のコーディング終了------------------------------------->

</div>
<!--/順位表TOP_メインコンテンツ-->


<!--他球団の試合-->
<div id="bbrCom_gameResult"></div>
<!--他球団の試合-->
<Copyright></Copyright>
</div>
</template>

<script>
import utilsMixin from '../utils';
import Copyright from './Copyright.vue';

export default {
  mixins: [utilsMixin],
  components: {
    Copyright
  },
  data: function () {
    return {
      json: null,
      tob: {
        'Top':'表',
        'Bottom':'裏',
      }
    }
  },
  mounted: async function() {
    await this.loadLatestGame();
    this.$config.callback();
  },
  methods: {

  }
}
</script>